import { render, staticRenderFns } from "./stepThree.vue?vue&type=template&id=5208edcc&scoped=true"
import script from "./stepThree.vue?vue&type=script&lang=js"
export * from "./stepThree.vue?vue&type=script&lang=js"
import style0 from "./stepThree.vue?vue&type=style&index=0&id=5208edcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208edcc",
  null
  
)

export default component.exports